module.exports = __webpack_public_path__ + "static/media/promo.ab339bad.png";